import { Link } from "react-router-dom";
import { Phone, Star, Shield, Clock } from "lucide-react";

/**
 * Slim trust-signal strip mounted below the navbar site-wide.
 * Communicates the 4 conversion-critical signals in one glance:
 * rating, response speed, licensing, phone.
 */
export default function TrustSignalStrip() {
  return (
    <div
      data-testid="trust-signal-strip"
      className="hidden md:block w-full border-b border-white/5 bg-gradient-to-r from-blue-950/30 via-transparent to-blue-950/30 backdrop-blur-sm py-2"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-wrap items-center justify-center gap-x-6 gap-y-1.5 text-xs md:text-sm">
        <div className="flex items-center gap-1.5 text-slate-300">
          <Star size={14} className="text-yellow-400 fill-yellow-400" />
          <span className="font-medium">5.0</span>
          <span className="text-slate-500 hidden sm:inline">· 89+ Google Reviews</span>
        </div>
        <div className="hidden md:flex items-center gap-1.5 text-slate-300">
          <Clock size={14} className="text-blue-400" />
          <span>Same-day booking available</span>
        </div>
        <div className="hidden md:flex items-center gap-1.5 text-slate-300">
          <Shield size={14} className="text-green-400" />
          <span>Licensed &amp; insured</span>
        </div>
        <Link
          to="tel:2398344377"
          data-testid="trust-strip-call"
          className="flex items-center gap-1.5 text-blue-300 hover:text-blue-200 font-medium transition-colors"
        >
          <Phone size={14} />
          <span>239-834-4377</span>
        </Link>
      </div>
    </div>
  );
}
